// extracted by mini-css-extract-plugin
export default {"container":"Xp-z","brandName":"Yp-z","productName":"Zp-z","productNamePdpEnhancements":"_p-z","breakLongProductName":"aq-z"};